module.exports = __webpack_public_path__ + "img/compact.030963c7.png";